import { Component, OnInit } from '@angular/core';
import { DashboardService } from '../shared/services/dashboardservices/dashboard.service';
import { SharedModeService } from '../shared/services/shared-mode.service';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
@Component({
  selector: 'app-salary-calculations',
  templateUrl: './salary-calculations.component.html',
  styleUrls: ['./salary-calculations.component.css'],
  standalone: true,
  imports: [CommonModule, FormsModule],
})
export class SalaryCalculationsComponent implements OnInit {

  basicSalary: any;
  basicSalaryTouched = false;
  yearly = 0;
  daily1 = 0;
  daily: any = "0";
  hourly1 = 0;
  hourly: any = "0";
  totalsalary = 0;
  basicSalaryInvalid: any;
  overtimeFactor = 0;
  paidleaveFactor = 0;
  showSalaryResult = false;
  leavedays = 1;
  overtime: any = "0";
  late: any = "0";
  unpaid1: any = "0";
  absent: any = "0";
  days: any = "0";
  showhourly: any = "0";
  tax: any = "0";
  // loanamount:any = "0";
  showovertime: any = "0";
  showlatecheckin: any = "0";
  showlunpaid: any = "0";
  showlabsent: any = "0";
  userInfo: any;
  colormode: any;
  selectedMode: any;
  datamode: any;
  user: any;
  constructor(
    public dashboardService: DashboardService,
    private sharedmode: SharedModeService,
  ) {
    this.user = JSON.parse(localStorage.getItem('user') || '');
    this.user_detail();

  }
  ngOnInit() {
    this.sharedmode.data$.subscribe(mode => {
      this.selectedMode = mode;
    });
  }
  toggleMode(mode: string) {
    this.datamode
    this.sharedmode.setMode(mode);
  }
  handleClick() {
    this.calculateSalaries();
    this.toggleSalaryResult();
  }

  toggleSalaryResult() {
    if (!this.showSalaryResult) {
      this.showSalaryResult = true;
    }
  }

  calculateSalaries() {

    this.basicSalaryTouched = true;

    if (!this.basicSalary) {
      return;
    }

    const MothsInYear = 12;
    this.yearly = this.basicSalary * MothsInYear;
    
    this.daily1 = (this.basicSalary * 12) / 365;
    this.daily = this.daily1.toFixed(2);
    this.hourly1 = this.daily1 / 8;
    this.totalsalary = this.basicSalary;
    this.hourly = this.hourly1.toFixed(2);
    this.overtime = (this.hourly * 1.5).toFixed(2);
    this.late = (this.hourly * 1.3).toFixed(2);
    this.unpaid1 = (this.daily * 1).toFixed(2);
    this.absent = (this.daily * 1.5).toFixed(2);
    // this.loanamount =
    if (this.yearly <= 600000) {
      this.tax = 0;
    } else if (this.yearly <= 1200000) {
      this.tax = (((this.yearly - 600000) * 0.025) / 12).toFixed(2);
    }
    else if (this.yearly <= 2400000) {
      this.tax = ((((this.yearly - 1200000) * 0.125) + 15000) / 12).toFixed(2);
    }
    else if (this.yearly <= 3600000) {
      this.tax = ((((this.yearly - 2400000) * 0.225) + 165000) / 12).toFixed(2);
    }
    else if (this.yearly <= 6000000) {
      this.tax = ((((this.yearly - 3600000) * 0.275) + 435000) / 12).toFixed(2);
    }
    else if (this.yearly > 6000000) {
      this.tax = ((((this.yearly - 6000000) * 0.35) + 1095000) / 12).toFixed(2);
    }


  }
  user_detail() {
    this.dashboardService.getuserdetail().then((value) => {
      this.userInfo = value.data
      this.colormode = this.userInfo.color_mode
      this.sharedmode.setMode(this.colormode);
    })

  }
}
